import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    colors,
    breakpoints,
    mediaQuery,
    gutterSizes,
} from '@gumtree/ui-library/src/base/theme';

export const MhhContainer = styled.nav<{ isSticky?: boolean }>`
    background-color: ${colors.blade};
    position: ${({ isSticky }) => (isSticky ? 'sticky' : 'relative')};
    ${({ isSticky }) => isSticky && 'top: 0; z-index: 1000;'}

    ${mediaQuery.from(breakpoints.large)} {
        display: none;
    }
`;

export const MhhInner = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: ${gutterSizes.large};
`;

export const LeftSection = styled.div`
    display: flex;
    flex: 1 0 0;
    align-items: center;
    gap: 12px;
    min-width: 0;
`;

export const LogoWrapper = styled.div`
    flex-shrink: 0;
    width: 24px;
    height: 30px;
    display: flex;
    align-items: center;

    .logo--small .logo-image svg {
        height: 30px;
    }
`;

export const SearchTrigger = styled.button`
    flex: 1 0 0;
    min-width: 0;
    display: flex;
    align-items: center;
    height: 34px;
    padding: 8px 12px;
    border-radius: 200px;
    border: none;
    background: ${colors.white};
    cursor: pointer;
    outline: none;
    box-sizing: border-box;

    &:focus-visible {
        outline: 2px solid #1b73e8;
    }
`;

export const PlaceholderScrollWrapper = styled.div`
    overflow: hidden;
    height: 18px;
    flex: 1;
    min-width: 0;
    text-align: left;
`;

const placeholderTextBase = `
    display: block;
    color: #81838d;
    font-size: 12px;
    font-weight: 330;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
`;

export const PlaceholderText = styled.span`
    ${placeholderTextBase}

    @keyframes mhhScrollUp {
        from {
            transform: translateY(100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    animation: mhhScrollUp 0.4s ease-out;
`;

export const PlaceholderTextStatic = styled.span`
    ${placeholderTextBase}
`;

export const ActionsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    .side-menu-container {
        margin-left: 6px;
    }
`;

export const iconButtonCss = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${colors.white};
    text-decoration: none;

    &:focus-visible {
        outline: 2px solid #1b73e8;
        outline-offset: 2px;
    }
`;

export const IconLabel = styled.span`
    font-size: 10px;
    font-weight: 330;
    line-height: 18px;
    color: ${colors.white};
    white-space: nowrap;
    text-align: center;
`;

export const MenuButtonWrapper = styled.div`
    position: relative;
    display: inline-flex;
`;

export const UnreadBadge = styled.div`
    position: absolute;
    top: -6px;
    right: -8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18.75px;
    height: 18.75px;
    padding: 0 4px;
    box-sizing: border-box;
    border-radius: 80px;
    background-color: #5ce00b;
    color: #0c132d;
    font-family: "Readex Pro", sans-serif;
    font-size: 11.719px;
    font-weight: 600;
    line-height: 18.75px;
    text-align: center;
`;

export const HiddenSearchBarWrapper = styled.div`
    height: 0;
    overflow: hidden;
`;
